import React from 'react';
import { observer } from 'mobx-react';
import { Divider } from 'antd';
import { RecordCard } from '@project/store/shared/RecordCard';
import AttachmentsCarousel from '@project/components/Module/RecordCard/AttachmentsCarousel';

import './style.scss';

interface CardHeaderProps {
  card: RecordCard;
}

export const CardHeader: React.FC<CardHeaderProps> = observer(
  function CardHeader({ card }) {
    const { partition, name } = card.cardInfo;

    const layerDescription = card.connectedLayer.error
      ? undefined
      : card.connectedLayer.description || card.connectedLayer.layerName;

    const images = card.attachments.images;

    const hasImages = images.length > 0;

    return (
      <div className="card-header-wrapper">
        <Divider className="divider" />

        {hasImages && (
          <div className="card-header-carousel-wrapper">
            <AttachmentsCarousel
              attachments={card.attachments.images}
              recordId={card.recordId}
              tableName={card.tableName}
            />
          </div>
        )}

        <div className={hasImages ? 'carousel' : ''}>
          <div className={'card-header'}>
            <p className={'card-header-table-name'}>
              {layerDescription || partition}
            </p>
          </div>
          <p className={'card-header-record-name'} title={name}>
            {name}
          </p>
        </div>
        <Divider className="divider" />
      </div>
    );
  },
);
